<template>
  <div id="box">
    <div id="container">
      <myhead></myhead>
      <main>
        <div class="left_bg"></div>
        <div class="right_log">
          <div class="title">对公账户认证</div>
          <!-- <div class="desc">
						<p class="all">可使用嗖嗖人力全部功能</p>
          </div>-->
          <p class="message">填写您公司的银行对公账户信息，我们将向您公司的账户打一笔随即数额的款项，请将收到的款项数额反馈给我们，以完成身份验证。</p>
          <div class="entry">
            <el-select
              v-model="bank"
              filterable
              remote
              reserve-keyword
              clearable
              placeholder="请输入银行名称"
              :remote-method="getBankList"
              style="width: 400px;margin-bottom: 10px;"
              :loading="loading"
            >
              <el-option v-for="item in bankList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
            <el-select
              v-model="provice"
              placeholder="请选择省份"
              @change="getCityList"
              style="width: 150px;margin-bottom: 10px;"
            >
              <el-option v-for="item in proviceList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
            <el-select
              v-model="city"
              style="width: 150px;margin-bottom: 10px;margin-left: 20px;"
              placeholder="请选择城市"
            >
              <el-option v-for="item in cityList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
            <el-input
              placeholder="请输入银行账户"
              v-model="bankAccount"
              style="width: 400px;margin-bottom: 10px;"
              clearable
            ></el-input>
            <el-select
              v-model="subBranch"
              filterable
              allow-create
              remote
              reserve-keyword
              clearable
              placeholder="请输入银行开户行名称"
              :remote-method="getSubBranchList"
              @change="getPrcptcd"
              style="width: 400px;margin-bottom: 10px;"
              :loading="loading"
            >
              <el-option v-for="item in subBranchList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
            <el-input
              placeholder="请输入银行支付联行号"
              v-model="bankPrcptcd"
              style="width: 400px;margin-bottom: 10px;"
              clearable
              :disabled="isDisabled"
            ></el-input>
          </div>
          <div class="footerBtn">
            <!-- <button class="btn" type="button" @click="onreturn">返回上一步</button> -->
            <button class="btn subbtn" @click="onsubmit">提交</button>
          </div>
        </div>
      </main>
      <myfoot></myfoot>
    </div>
  </div>
</template> 

<script>
export default {
  name: "AccountCllect",
  data() {
    return {
      loading: false,
      id: this.$route.query.id,
      name: this.$route.query.name,
      subBranch: "",
      bank: "",
      bankAccount: "",
      bankPrcptcd: "",
      provice: "",
      city: "",
      bankList: [],
      proviceList: [],
      cityList: [],
      subBranchList: [],
      isDisabled: false,
    };
  },
  mounted() {
    // this.$refs.log.source = "validate";
    this.getProviceList();
  },
  methods: {
    onsubmit() {
      if (this.bank == "") {
        this.$message.error("请输入银行名称");
        return;
	  }else if(this.provice == ''){
		this.$message.error("请选择省份");
        return;
	  }else if(this.city == ''){
		this.$message.error("请选择城市");
        return;
	  } 
	  else if (this.bankAccount == "") {
        this.$message.error("请输入银行账户");
        return;
      } else if(this.subBranch == ''){
		this.$message.error("请输入银行开户行名称");
        return;
	  }
      const params = {};
      params.id = this.id;
      params.name = this.name;
      params.bank = this.bank;
      params.cardno = this.bankAccount;
      params.subBranch = this.subBranch;
      params.prcptcd = this.bankPrcptcd;
      params.provice = this.provice;
      params.city = this.city;
      this.$axios
        .post("/companyContract/validAuthRemittance", params)
        .then((res) => {
          if (res.data.status == 1) {
            this.$confirm(
              "我们已向您公司的账户打了一笔随机数额的款项，请前往 嗖嗖人力个人中心【企业设置】相关界面中将收到的款项数 额反馈给我们，以完成身份验证",
              "提示",
              {
                confirmButtonText: "我知道了",
                showCancelButton: false,
                iconClass: "el-icon-advanced",
              }
            ).then(() => {
              this.$router.push({
                path: "/main/system/system/company",
              });
            });
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    getBankList(query) {
      if (query !== "") {
        this.loading = true;
        this.$axios
          .get("/companyContract/getBankList?name=" + query)
          .then((res) => {
            if (res.data.status == 1) {
              this.loading = false;
              this.bankList = res.data.data;
            }
          });
      } else {
        this.bankList = [];
      }
    },
    getSubBranchList(query) {
      if (query !== "") {
        this.loading = true;
        this.$axios
          .get("/companyContract/getBankBList?name=" + query, {})
          .then((res) => {
            if (res.data.status == 1) {
              this.loading = false;
              this.subBranchList = res.data.data;
            }
          });
      } else {
        this.subBranchList = [];
      }
    },
    getPrcptcd(query) {
      if (query !== "") {
        this.loading = true;
        this.$axios
          .get("/companyContract/getBankPrcptcd?name=" + query, {})
          .then((res) => {
            if (res.data.status == 1) {
              this.loading = false;
              if (res.data.data != null) {
                this.isDisabled = true;
                this.bankPrcptcd = res.data.data;
              } else {
                this.isDisabled = false;
                this.bankPrcptcd = "";
              }
            }
          });
      } else {
        this.bankPrcptcd = "";
      }
    },
    getProviceList() {
      this.$axios.get("/companyContract/getBankPList", {}).then((res) => {
        if (res.data.status == 1) {
          var arr = res.data.data;
          var one = res.data.data[0];
          var two = res.data.data[3];
          arr.splice(0, 1, two);
          arr.splice(3, 1, one);
          this.proviceList = arr;
        }
      });
    },
    getCityList() {
      this.$axios
        .get("/companyContract/getBankCList?provice=" + this.provice, {})
        .then((res) => {
          if (res.data.status == 1) {
            this.city = "";
            this.cityList = res.data.data;
          }
        });
    },
    onreturn() {
      this.$router.push({
        path: "/main/system/system/company",
      });
    },
  },
};
</script>

<style scoped lang="less">
#app {
  position: relative;
}

#box {
  width: 100%;
  min-width: 1184px;
  background-color: #292b52;
  position: absolute;
  top: 0;
  bottom: 0;
  overflow: auto;

  #container {
    width: 1184px;
    margin: 0 auto;

    main {
      width: 100%;
      height: 560px;
      background-color: #fff;
      border-radius: 6px;
      display: flex;
      justify-content: space-around;

      /*overflow: hidden;*/
      .left_bg {
        width: 420px;
        height: 100%;
        background-image: url(../../../assets/img/1_10.png);
        background-repeat: no-repeat;
        background-position: center;
      }

      .right_log {
        width: 414px;
        height: 560px;

        // margin-top: 30px;
        .desc {
          display: flex;
          align-items: center;
          color: #0bb27a;
          font-size: 14px;
          margin: 10px 0;
        }

        .desc:after {
          content: "";
          width: 100px;
          height: 1px;
          background-color: #a8a8b3;
          margin-left: 20px;
        }

        .desc:before {
          content: "";
          width: 120px;
          height: 1px;
          background-color: #a8a8b3;
          margin-right: 20px;
        }

        .message {
          font-size: 12px;
          color: #555;
          margin: 30px 0;
        }

        .entry {
          margin: 10px 0;
        }

        .footerBtn {
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin-top: 20px;

          .btn {
            width: 100%;
          }

          .btn subbtn {
            width: 100%;
          }
        }

        .title {
          font-size: 30px;
          text-align: center;
          color: #000000;
          font-weight: bold;
          background-color: #fff;
          margin-top: 57px;
        }
      }
    }
  }
}

@media (min-height: 720px) {
  #container {
    width: 1184px !important;
    height: 720px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto !important;
  }
}
</style>
